import {
	COMPONENT_STATES,
	COMPONENT_TYPE as TYPE,
	DEFAULT_MEDIA_QUERY_PLATFORMS,
	UNIFORM_PROPS,
} from 'common/constants';
import { getText } from 'common/utils/dictionary';
import View from 'client/components/common/BuildingBlocks/Fields/TextField/TextField';
import { generateElementId, generateNodeId } from 'client/components/common/BuildingBlocks/utils/common';
import { FIELD_BB_ERROR_TYPE, FIELD_BB_STYLE, FIELD_BB_TYPE } from '../constants';

/**
 * @param options {Object=}
 * @param options.dictionary {Object=}
 * @returns {{ view, model }}
 * @constructor
 */
export const TEXT_FIELD = (options = {}) => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.TEXT_FIELD;

			return {
				_id,
				type,
				uiConfig: {
					layer: undefined,
					editorProps: {
						name: TEXT_FIELD.displayName,
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
						[UNIFORM_PROPS.fieldErrorShow]: FIELD_BB_ERROR_TYPE.REQUIRED,
					},

					componentProps: {
						[UNIFORM_PROPS.fieldType]: FIELD_BB_TYPE.TEXT,
						[UNIFORM_PROPS.fieldPlaceholder]: getText(
							// @ts-expect-error ts-migrate FIXME
							options.dictionary,
							type,
							UNIFORM_PROPS.fieldPlaceholder
						),
						// [UNIFORM_PROPS.fieldError]: {
						// 	// [FIELD_BB_ERROR_TYPE.REQUIRED]: 'required',
						// 	// [FIELD_BB_ERROR_TYPE.EMAIL]: 'email is required',
						// 	// ...
						// },
						styles: {
							[COMPONENT_STATES.DEFAULT]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									[FIELD_BB_STYLE.TEXT.PH_COLOR]: 'rgba(0, 0, 0, 0.54)',
								},
							},
						},
						other: {
							// 	[COMPONENT_STATES.DEFAULT]: {
							// 		[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
							// 			// ...
							// 		},
							// 	},
						},
					},
					nodeProps: {
						id: generateNodeId(_id, TEXT_FIELD.displayName),
					},
				},
				children: [],
			};
		},
	};
};

TEXT_FIELD.displayName = 'TextField';
